import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import { useNotification } from "~hooks/useNotification.ts";
import type { SearchFilterParams } from "~pages/Conducts/ConductListPage/types/searchFilterParams.ts";
import type { Conduct } from "~types/conduct.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useDeleteConduct = (params: SearchFilterParams) => {
  const { sport, organizationId } = useParams();
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const request = useApi();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (conductId: string) => {
      return await request(`${sport}/o/${organizationId}/conduct/${conductId}`, { method: "DELETE" });
    },
    onSuccess: (response: DefaultOperationSuccessResponse, conductId: string) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        queryClient.setQueryData<{ data: Array<Conduct> } | undefined>(["conducts", sport, organizationId, params], (oldValues) => {
          return {
            ...oldValues,
            data: oldValues?.data?.filter((item: Conduct) => item?.conductId !== conductId) || [],
          };
        });
        notification.success({
          message: formatMessage({ id: "conduct.delete.success" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
